import React from "react";
import { Link } from "react-router-dom";

export const PRIVACY_LAST_UPDATED = "28 de agosto de 2026";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-8 py-12">
      <p className="uppercase tracking-[0.3em] text-xs text-[var(--text-secondary)]">FaithCycle</p>
      <h1 className="font-serif text-4xl md:text-5xl tracking-tight mt-2">
        Política de Privacidad
      </h1>
      <p className="text-sm text-[var(--text-secondary)] mt-3">
        Última actualización: {PRIVACY_LAST_UPDATED}
      </p>

      <div className="mt-10 space-y-4 font-serif-body leading-relaxed text-[var(--text-primary)]">
        <PrivacyBody />
      </div>

      <div className="mt-12 pt-6 border-t border-[var(--border)] flex flex-wrap gap-3">
        <Link to="/" className="text-sm uppercase tracking-widest text-[var(--accent)] hover:underline">
          ← Volver al inicio
        </Link>
      </div>
    </div>
  );
}

export function PrivacyBody() {
  return (
    <>
      <p>
        FaithCycle ("FaithCycle", "nosotros", "nuestro" o "la Plataforma") respeta la privacidad de nuestros usuarios y se
        compromete a proteger la información personal que recopilamos a través de nuestra aplicación, sitio web y servicios
        relacionados.
      </p>
      <p>
        Esta Política de Privacidad explica qué información podemos recopilar, cómo la utilizamos, cómo la protegemos y cuáles
        son las opciones que usted tiene respecto a su información.
      </p>
      <p>
        Al utilizar FaithCycle, usted acepta las prácticas descritas en esta Política de Privacidad, así como las normas de
        conducta establecidas en este documento.
      </p>

      <H2>1. Información que recopilamos</H2>
      <p>Dependiendo de cómo utilice FaithCycle, podemos recopilar las siguientes categorías de información:</p>
      <H3>A. Información proporcionada por usted</H3>
      <p>Podemos recopilar información que usted proporciona voluntariamente, incluyendo:</p>
      <UL items={[
        "Nombre y apellido.",
        "Dirección de correo electrónico.",
        "Nombre de usuario.",
        "Contraseña o información necesaria para iniciar sesión.",
        "Fotografía de perfil, si decide proporcionarla.",
        "Información relacionada con su cuenta.",
        "Información que usted publique voluntariamente dentro de la Plataforma.",
        "Mensajes, comentarios, testimonios, solicitudes de oración u otro contenido que usted decida compartir.",
      ]} />
      <H3>B. Información recopilada automáticamente</H3>
      <p>Cuando utiliza FaithCycle, podemos recopilar determinada información técnica, como:</p>
      <UL items={[
        "Tipo de dispositivo.",
        "Sistema operativo.",
        "Dirección IP.",
        "Identificadores del dispositivo.",
        "Tipo de navegador.",
        "Información sobre el uso de la aplicación.",
        "Fecha y hora de acceso.",
        "Páginas o funciones utilizadas.",
        "Información necesaria para diagnosticar errores y mejorar el funcionamiento de la Plataforma.",
      ]} />

      <H2>2. Cómo utilizamos su información</H2>
      <p>FaithCycle puede utilizar la información recopilada para:</p>
      <UL items={[
        "Crear y administrar su cuenta.",
        "Proporcionar las funciones y servicios de la Plataforma.",
        "Permitirle participar en comunidades, grupos o actividades dentro de FaithCycle.",
        "Facilitar comunicaciones entre usuarios cuando dichas funciones estén disponibles.",
        "Enviar notificaciones relacionadas con la cuenta y los servicios.",
        "Responder preguntas y solicitudes de soporte.",
        "Personalizar y mejorar la experiencia del usuario.",
        "Detectar, prevenir e investigar actividades fraudulentas, abusivas o no autorizadas.",
        "Mantener la seguridad de la Plataforma.",
        "Analizar el uso y rendimiento de nuestros servicios.",
        "Revisar y moderar contenido que pueda infringir nuestras normas de conducta.",
        "Cumplir con obligaciones legales aplicables.",
      ]} />
      <p>
        FaithCycle no utilizará la información personal de los usuarios para fines incompatibles con los descritos en esta
        Política sin proporcionar la información o consentimiento requerido por la ley aplicable.
      </p>

      <H2>3. Información relacionada con contenido cristiano</H2>
      <p>
        FaithCycle puede permitir que los usuarios compartan contenido relacionado con su fe, incluyendo testimonios,
        peticiones de oración, estudios bíblicos, comentarios, reflexiones y participación en grupos.
      </p>
      <p>
        Usted debe tener presente que cualquier información que publique voluntariamente en áreas públicas o visibles para
        otros usuarios puede dejar de considerarse privada.
      </p>
      <p>
        Le recomendamos no publicar información personal sensible, incluyendo números de identificación, información
        financiera, contraseñas, direcciones particulares u otra información que no desee compartir públicamente.
      </p>

      <H2>4. Peticiones de oración y contenido personal</H2>
      <p>
        Si FaithCycle ofrece una función para enviar peticiones de oración, el usuario entiende que el contenido enviado
        puede ser almacenado y procesado para proporcionar dicha función.
      </p>
      <p>
        Las peticiones de oración pueden contener información personal o información sensible proporcionada voluntariamente
        por el usuario. Los usuarios deben evitar incluir información innecesaria sobre terceros, especialmente información
        médica, financiera, de contacto u otra información privada.
      </p>
      <p>
        FaithCycle no requiere que los usuarios revelen información personal sensible para utilizar las funciones generales
        de la Plataforma.
      </p>

      <H2>5. Normas de conducta y contenido inapropiado</H2>
      <p>
        FaithCycle busca mantener una comunidad respetuosa, segura y coherente con sus valores cristianos. Por esta razón,
        los usuarios deben abstenerse de publicar, enviar o compartir palabras ofensivas, insultos, lenguaje vulgar,
        contenido inapropiado, amenazas, acoso, discriminación, contenido sexual explícito o cualquier otro material que
        pueda afectar la seguridad, dignidad o bienestar de otros usuarios.
      </p>
      <p>
        FaithCycle podrá revisar, moderar, eliminar o restringir el acceso a cualquier contenido que considere ofensivo,
        inapropiado, abusivo o contrario a estas normas.
      </p>
      <p>
        El uso de palabras ofensivas o inapropiadas, así como la publicación o envío repetido de contenido que infrinja
        estas normas, podrá resultar en la suspensión o bloqueo permanente de la cuenta del usuario. Cuando una cuenta sea
        bloqueada permanentemente, el usuario no podrá iniciar sesión ni acceder nuevamente al sitio web, la aplicación o
        los servicios de FaithCycle.
      </p>
      <p>
        FaithCycle también podrá tomar medidas adicionales cuando sea necesario para proteger a los usuarios, investigar
        abusos, prevenir daños o cumplir con obligaciones legales.
      </p>

      <H2>6. Compartir información con terceros</H2>
      <p>FaithCycle puede utilizar proveedores de servicios externos para ayudar a operar la Plataforma. Estos proveedores pueden prestar servicios relacionados con:</p>
      <UL items={[
        "Hospedaje y almacenamiento de datos.",
        "Autenticación de usuarios.",
        "Procesamiento de pagos.",
        "Envío de correos electrónicos o notificaciones.",
        "Analítica y rendimiento.",
        "Seguridad.",
        "Servicio al cliente.",
        "Prevención de fraude.",
        "Moderación y protección de la comunidad.",
      ]} />
      <p>
        Estos proveedores solamente podrán acceder a la información necesaria para prestar los servicios correspondientes y
        estarán sujetos a obligaciones contractuales o legales aplicables.
      </p>
      <p>FaithCycle no vende deliberadamente la información personal de sus usuarios.</p>

      <H2>7. Pagos</H2>
      <p>
        Si FaithCycle ofrece productos, membresías, donaciones, suscripciones u otros servicios que requieran pagos, los
        pagos pueden ser procesados por proveedores externos de servicios de pago.
      </p>
      <p>FaithCycle no necesariamente almacena directamente los números completos de tarjetas de crédito o débito.</p>
      <p>
        La información relacionada con pagos estará sujeta también a las políticas de privacidad y términos del proveedor
        de procesamiento de pagos correspondiente.
      </p>

      <H2>8. Cookies y tecnologías similares</H2>
      <p>Nuestro sitio web o aplicación puede utilizar cookies, identificadores y tecnologías similares para:</p>
      <UL items={[
        "Mantener sesiones activas.",
        "Recordar determinadas preferencias.",
        "Analizar el uso de nuestros servicios.",
        "Mejorar la seguridad.",
        "Mejorar el funcionamiento de la Plataforma.",
      ]} />
      <p>
        Usted puede controlar determinadas cookies mediante la configuración de su navegador o dispositivo, aunque
        deshabilitar algunas tecnologías puede afectar determinadas funciones.
      </p>

      <H2>9. Comunicaciones</H2>
      <p>Podemos enviarle comunicaciones relacionadas con:</p>
      <UL items={[
        "Su cuenta.",
        "Seguridad.",
        "Cambios importantes en nuestros servicios.",
        "Actualizaciones de la Plataforma.",
        "Soporte técnico.",
        "Moderación o medidas aplicadas a su cuenta.",
        "Otras comunicaciones necesarias para proporcionar el servicio.",
      ]} />
      <p>Cuando corresponda, podremos ofrecer opciones para dejar de recibir comunicaciones promocionales.</p>

      <H2>10. Seguridad</H2>
      <p>
        FaithCycle implementa medidas razonables de seguridad diseñadas para proteger la información personal contra
        acceso, pérdida, alteración, divulgación o destrucción no autorizada.
      </p>
      <p>
        Sin embargo, ningún sistema electrónico, aplicación, sitio web o método de transmisión por Internet puede
        garantizar una seguridad absoluta. Por esta razón, no podemos garantizar que la información estará completamente
        protegida frente a todas las posibles amenazas.
      </p>

      <H2>11. Retención de información</H2>
      <p>Conservaremos la información personal durante el tiempo razonablemente necesario para:</p>
      <UL items={[
        "Mantener su cuenta.",
        "Proporcionar nuestros servicios.",
        "Cumplir obligaciones legales.",
        "Resolver disputas.",
        "Hacer cumplir nuestros acuerdos y normas de conducta.",
        "Prevenir fraude, abuso y contenido inapropiado.",
        "Mantener registros comerciales legítimos.",
      ]} />
      <p>
        Cuando la información ya no sea necesaria, podremos eliminarla, anonimizarla o conservarla cuando exista una razón
        legal o legítima para hacerlo. En caso de bloqueo o suspensión de una cuenta, podremos conservar determinada
        información y registros relacionados con la infracción para proteger la Plataforma, prevenir reincidencias,
        resolver disputas y cumplir con obligaciones legales.
      </p>

      <H2>12. Eliminación de su cuenta</H2>
      <p>
        Dependiendo de las funciones disponibles en FaithCycle, usted podrá solicitar la eliminación de su cuenta y de
        determinada información personal.
      </p>
      <p>
        Las solicitudes de eliminación pueden estar sujetas a obligaciones legales, seguridad, prevención de fraude,
        investigación de abusos, aplicación de nuestras normas de conducta o conservación de determinados registros.
      </p>
      <p>
        La eliminación de una cuenta bloqueada no necesariamente eliminará todos los registros relacionados con la
        infracción cuando su conservación sea necesaria por razones legales, de seguridad o de protección de la comunidad.
      </p>
      <p>
        Para solicitar la eliminación de su cuenta o información personal, comuníquese con nosotros utilizando la
        información de contacto indicada al final de esta Política.
      </p>

      <H2>13. Privacidad de los menores</H2>
      <p>
        FaithCycle no está diseñado para recopilar deliberadamente información personal de niños sin las autorizaciones
        requeridas por la legislación aplicable.
      </p>
      <p>
        Si usted es padre, madre o tutor legal y considera que un menor ha proporcionado información personal a FaithCycle
        sin la autorización correspondiente, puede comunicarse con nosotros para solicitar que revisemos y, cuando
        corresponda, eliminemos dicha información.
      </p>

      <H2>14. Enlaces a otros sitios o servicios</H2>
      <p>FaithCycle puede contener enlaces o integraciones con sitios, aplicaciones o servicios operados por terceros.</p>
      <p>FaithCycle no controla las prácticas de privacidad de esos terceros.</p>
      <p>Le recomendamos revisar las políticas de privacidad de cualquier servicio externo antes de proporcionar información personal.</p>

      <H2>15. Derechos de privacidad</H2>
      <p>Dependiendo de su lugar de residencia y de las leyes aplicables, usted puede tener determinados derechos respecto a su información personal, incluyendo:</p>
      <UL items={[
        "Solicitar acceso a determinada información personal.",
        "Solicitar la corrección de información incorrecta.",
        "Solicitar la eliminación de información.",
        "Solicitar información sobre cómo se utiliza su información.",
        "Retirar determinados consentimientos cuando corresponda.",
        "Oponerse a determinados usos de su información.",
        "Solicitar una copia de determinados datos personales.",
      ]} />
      <p>Para ejercer un derecho aplicable, puede comunicarse con FaithCycle mediante la información indicada a continuación.</p>
      <p>Podremos solicitar información razonablemente necesaria para verificar su identidad antes de procesar determinadas solicitudes.</p>

      <H2>16. Residentes de determinados estados de Estados Unidos</H2>
      <p>Dependiendo de su estado de residencia, usted puede tener derechos adicionales relacionados con la privacidad de sus datos personales.</p>
      <p>FaithCycle procurará cumplir con las leyes de privacidad aplicables a los usuarios y responderá a solicitudes válidas de acuerdo con la legislación correspondiente.</p>
      <p>Si una ley estatal aplicable le proporciona derechos adicionales, dichos derechos prevalecerán en la medida requerida por la ley.</p>

      <H2>17. Residentes de otros países</H2>
      <p>Si utiliza FaithCycle desde fuera de Estados Unidos, su información puede ser procesada y almacenada en Estados Unidos u otros países donde nosotros o nuestros proveedores de servicios operen.</p>
      <p>Las leyes de privacidad de esos países pueden ser diferentes de las de su país de residencia.</p>
      <p>Cuando sea requerido por la legislación aplicable, adoptaremos las medidas necesarias para proporcionar las protecciones correspondientes.</p>

      <H2>18. Cambios a esta Política de Privacidad</H2>
      <p>Podemos actualizar esta Política de Privacidad periódicamente.</p>
      <p>Cuando realicemos cambios importantes, podremos publicar la nueva versión dentro de la Plataforma o mediante otros medios razonables.</p>
      <p>La fecha de "Última actualización" ubicada al principio de esta Política indicará cuándo fue modificada por última vez.</p>
      <p>Le recomendamos revisar periódicamente esta Política.</p>

      <H2>19. Contacto</H2>
      <p>Si tiene preguntas sobre esta Política de Privacidad, desea ejercer sus derechos de privacidad o necesita asistencia relacionada con sus datos personales, puede comunicarse con nosotros:</p>
      <p>
        <strong>FaithCycle</strong><br />
        Sitio web: <a href="https://faithcycle.net" className="text-[var(--accent)] hover:underline">FaithCycle.net</a><br />
        Correo electrónico de privacidad: <a href="mailto:vegallmc@gmail.com" className="text-[var(--accent)] hover:underline">vegallmc@gmail.com</a>
      </p>

      <H2>20. Aceptación</H2>
      <p>Al crear una cuenta o utilizar FaithCycle, usted reconoce que ha leído y comprendido esta Política de Privacidad y las normas de conducta establecidas en ella.</p>
      <p>Si no está de acuerdo con esta Política o con las normas de conducta, deberá dejar de utilizar la Plataforma.</p>
      <p>El incumplimiento de estas normas, incluyendo el uso de palabras ofensivas o inapropiadas, puede resultar en el bloqueo permanente de la cuenta y en la pérdida del acceso al sitio web, la aplicación y los servicios de FaithCycle.</p>
      <p className="italic text-[var(--text-secondary)] mt-6">FaithCycle — Creciendo juntos en la fe.</p>
    </>
  );
}

function H2({ children }) {
  return <h2 className="font-serif text-2xl md:text-3xl tracking-tight mt-10 mb-2 text-[var(--text-primary)]">{children}</h2>;
}
function H3({ children }) {
  return <h3 className="font-serif text-lg tracking-tight mt-5 mb-1 text-[var(--text-primary)]">{children}</h3>;
}
function UL({ items }) {
  return (
    <ul className="list-disc pl-6 space-y-1 my-3">
      {items.map((it, i) => <li key={i}>{it}</li>)}
    </ul>
  );
}
